import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// DJB-112: pages with default-collapsed accordion sections call this to honour
// the left nav's section deep-links. The nav appends ?section=<anchor> when a
// section is picked from the menu; this hook maps that anchor to the page's
// section key and asks the page to open it. Keyed on the location object (not
// just the search string) so re-clicking the same menu entry re-opens a
// section the user collapsed in the meantime.
const useDeepLinkedSection = (anchorToSectionKey, openSection) => {
  const location = useLocation();

  // Callers pass inline maps/callbacks; refs keep the effect from re-firing on
  // every render while still using the latest values.
  const mapRef = useRef(anchorToSectionKey);
  mapRef.current = anchorToSectionKey;
  const openRef = useRef(openSection);
  openRef.current = openSection;

  useEffect(() => {
    const anchor = new URLSearchParams(location.search).get('section');
    const sectionKey = anchor ? mapRef.current[anchor] : undefined;
    if (sectionKey) {
      openRef.current(sectionKey);
    }
  }, [location]);
};

export default useDeepLinkedSection;
